
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.815 9.8h14.63c1.155 0 2.09 1.06 2.09 2.367v8.285c0 1.307-.935 2.367-2.09 2.367H3.815c-1.155 0-2.09-1.06-2.09-2.367v-8.285c0-1.307.936-2.367 2.09-2.367zM5.904 9.8V6.01c0-2.618 2.34-4.739 5.226-4.739s5.225 2.121 5.225 4.738V9.8M11.129 13.398v3.255","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    